import { motion } from "framer-motion";

export const EASE_EDITORIAL = [0.22, 1, 0.36, 1];
export const EASE_PORTAL = [0.16, 1, 0.3, 1];

export default function Reveal({
  children,
  className = "",
  delay = 0,
  y = 28,
  testid,
}) {
  return (
    <motion.div
      className={className}
      data-testid={testid}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: EASE_EDITORIAL, delay }}
    >
      {children}
    </motion.div>
  );
}
